<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FaxChain 节点类型</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">FaxChain 用户类型</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">提议者的职责</a></p>
          <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">test</a></p> -->
          <!-- <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">test</a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">基本概念</div>
      <div id="box1" class="p2">FaxChain 节点类型</div>
      <div class="p4">全节点</div>
      <div class="p3">全节点是验证区块链交易和区块的程序。与只处理区块头和少量交易的轻量级节点不同，它需要更多的资源来运行全节点，这是成为提议者的必要步骤。此外，全节点还可用于为应用程序提供稳定且低延迟的区块链 API。</div>
      <div class="p4">验证</div>
      <div class="p3">验证人的作用是行使出块权，享有链上治理权。在一个投票会话中，从 FAX 投票者那里获得最多票数的 21 个节点被选为下一个周期的验证者。</div>
      <div id="box2" class="p2">FaxChain 用户类型</div>
      <div class="p4">普通用户</div>
      <div class="p3">普通用户是 FAX 持有者。</div>
      <div class="p4">委托人</div>
      <div class="p3">FaxChain 依靠一组提议者来维护网络安全。验证节点的作用是运行一个全节点，通过广播投票（包括发送者私钥签名的密文）参与共识。验证节点能够跟踪链上数据，在区块链上放置新块并获得收益以激励其操作。验证节点只有在成功连接到 FaxChain 网络后才能被选举。</div>
      <div class="p4">提议者</div>
      <div class="p3">提议者打包交易并通知其他验证者验证。</div>
      <div class="p4">候选提议者</div>
      <div class="p3">待补充</div>
      <div id="box3" class="p2">提议者的职责</div>
      <div class="p3">提议者有两个主要职责：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li>能够持续运行正确版本的软件：提议者需要确保他们的服务器始终在线并且他们的私钥不被泄露。</li>
          <li>积极参与治理：提案人必须对每个提案进行投票。</li>
        </ul>
      </div>
      <div class="p3">此外，提议者将成为社区的活跃成员。它们应该始终与生态系统的当前状态保持同步，以便轻松适应任何变化。</div>
      <div class="p3"></div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FaxChain 节点类型</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">FaxChain 用户类型</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">提议者的职责</a></p>
      <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">test</a></p> -->
      <!-- <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">test</a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'basicConcepts',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>